export default "/_next/static/chunks/fonts/Quicksand-Bold-latin-7b62a0f585cfe45e6a059f2a8f318b10.woff2";